"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackerType = void 0;
var BackerType;
(function (BackerType) {
    BackerType["None"] = "";
    BackerType["Kickstarter"] = "Kickstarter";
    BackerType["Other"] = "Other";
})(BackerType = exports.BackerType || (exports.BackerType = {}));
//# sourceMappingURL=backer.js.map